import { graphql } from "generated/gql";

export const getEntitySuggestionsDocument = graphql(/* GraphQL */ `
  query GetEntitySuggestions(
    $organisationSubdomain: String!
    $collectionSiteSlug: String!
    $search: String!
  ) {
    org: organisationBySubdomain(subdomain: $organisationSubdomain) {
      taxa(searchTerm: {field: SCIENTIFIC_NAME, value: $search} last: 10) {
        nodes {
          __typename
          id
          scientificName
          commonName
        }
      }
      site: collectionSiteBySlug(slug: $collectionSiteSlug) {
        accessions(searchTerm: {field: ACCESSION_NUM, value: $search} last: 10) {
          nodes {
            __typename
            id
            accessionNumber
            scientificName
          }
        }
        plantMaterials(searchTerm: {field: MATERIAL_NUMBER, value: $search} last: 10) {
          nodes {
            __typename
            id
            status
            qualifier
            accession {
              accessionNumber
              scientificName
            }
          }
        }
      }
    }
  }
`);
